import { render, staticRenderFns } from "./modal-scoring.vue?vue&type=template&id=452f7724&"
import script from "./modal-scoring.vue?vue&type=script&lang=js&"
export * from "./modal-scoring.vue?vue&type=script&lang=js&"
import style0 from "./modal-scoring.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports